import React from "react";
import styles from "./css/SectionHeader.module.css";

const SectionHeader = ({
  underlinePrefix = "",
  titleText = "",
  accentText = "",
  afterText = "",
  subtext = "",
  theme = "light",
  accentVariant = "green",
  className = "",
  titleClassName = "",
  subtextClassName = "",
  children,
}) => {
  const isDark = theme === "dark";
  const titleColorClass = isDark ? styles.titleDark : styles.titleLight;
  const subtextColorClass = isDark ? styles.subtextDark : styles.subtextLight;
  const accentClass =
    accentVariant === "bright" || isDark
      ? styles.accentBright
      : styles.accentGreen;
  const underlineClass = isDark
    ? `${styles.underlineSpan} ${styles.underlineSpanDark}`
    : styles.underlineSpan;

  return (
    <div className={`${styles.sectionHeader} ${className}`}>
      <h2
        className={`${styles.title} ${titleColorClass} ${titleClassName}`}
        data-aos="fade-up"
      >
        {children ? (
          children
        ) : (
          <>
            <span>
              {underlinePrefix && (
                <span className={underlineClass}>{underlinePrefix}</span>
              )}
              {titleText}
            </span>
            {accentText && <span className={accentClass}>{accentText}</span>}
            {afterText && <span>{afterText}</span>}
          </>
        )}
      </h2>

      {subtext && (
        <p
          className={`${styles.subtext} ${subtextColorClass} ${subtextClassName}`}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {subtext}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
